import React from 'react';
import { DialogUI } from '../Interface';
import ProdNonProductiveWorkPage from './ProdNonProductiveWorkPage';
import { Box } from '@mui/material';

const ProdNonProductiveWorkDialog = ({ handleClose, dialogData }) => {
  const { open, data } = dialogData;

  return (
    <DialogUI
      open={open}
      headerContent="Lejelentés"
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      maxWidth="sm"
    >
      <Box mt="1rem">
        <ProdNonProductiveWorkPage dialog={{ data, handleClose }} />
      </Box>
    </DialogUI>
  );
};

export default ProdNonProductiveWorkDialog;
